export const LaptopFrame = ({ src, alt, className = "" }) => (
  <div className={className}>
    <div className="rounded-t-2xl border border-navyline bg-[#0D1526] p-2 pb-0 shadow-2xl shadow-black/60">
      <div className="flex items-center gap-1.5 px-3 py-2">
        <span className="h-2.5 w-2.5 rounded-full bg-[#31415F]" />
        <span className="h-2.5 w-2.5 rounded-full bg-[#31415F]" />
        <span className="h-2.5 w-2.5 rounded-full bg-[#31415F]" />
        <span className="ml-3 flex-1 truncate rounded-md bg-ink/80 px-3 py-1 font-mono text-[10px] text-slate-500">
          drtrancollegeconsulting.net
        </span>
      </div>
      <div className="overflow-hidden rounded-t-lg border-t border-navyline/60">
        <img src={src} alt={alt} className="h-auto w-full object-cover object-top" />
      </div>
    </div>
    <div className="h-3.5 rounded-b-2xl border border-t-0 border-navyline bg-gradient-to-b from-[#1A2440] to-[#080D1A]">
      <div className="mx-auto h-full w-28 rounded-b-lg bg-[#05080F]" />
    </div>
  </div>
);

export const PhoneFrame = ({ src, alt, className = "" }) => (
  <div className={`rounded-[2.2rem] border border-navyline bg-[#0D1526] p-1.5 shadow-2xl shadow-black/70 ${className}`}>
    <div className="relative overflow-hidden rounded-[1.75rem]">
      <div className="absolute left-1/2 top-2 z-10 h-4 w-20 -translate-x-1/2 rounded-full bg-[#0D1526]" />
      <img src={src} alt={alt} className="h-auto w-full object-cover object-top" />
    </div>
  </div>
);

export default function HeroDevices() {
  return (
    <div className="relative" data-testid="hero-device-mockups">
      <div
        className="absolute -inset-10 -z-10 rounded-full opacity-60"
        style={{ background: "radial-gradient(closest-side, rgba(212,175,55,0.14), transparent)" }}
        aria-hidden="true"
      />
      <LaptopFrame
        src="/assets/drtran-desktop.jpg"
        alt="Dr. Tran College Consulting website homepage on a laptop — designed and built by AT Digital"
        className="relative z-10"
      />
      <PhoneFrame
        src="/assets/drtran-mobile.jpg"
        alt="Dr. Tran College Consulting website mobile view — responsive design by AT Digital"
        className="absolute -bottom-8 -right-2 z-20 w-28 sm:-right-6 sm:w-36 lg:w-40"
      />
      <div
        data-testid="hero-live-badge"
        className="absolute -left-3 top-6 z-30 flex items-center gap-2 rounded-full border border-gold/40 bg-ink/90 px-4 py-2 backdrop-blur sm:-left-6"
      >
        <span className="relative flex h-2 w-2">
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-gold opacity-60" />
          <span className="relative inline-flex h-2 w-2 rounded-full bg-gold" />
        </span>
        <span className="font-mono text-[10px] font-semibold tracking-[0.2em] text-gold">LIVE CLIENT WEBSITE</span>
      </div>
    </div>
  );
}
